import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CrmStatus } from 'Douleutaras/redux/data/v2/crm/crmSlice';
import { ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const crmStatusesAdapter = createEntityAdapter<CrmStatus>({
  selectId: item => item.level
});

export const crmStatusesSlice = createSlice({
  name: 'crmStatuses',
  initialState: crmStatusesAdapter.getInitialState({
    entities: [],
    meta: {}
  } as ReduxEntity<CrmStatus>),
  reducers: {
    crmStatusesAdded: (state, action) => {
      crmStatusesAdapter.setMany(state, action.payload);
    }
  },
  extraReducers: () => {}
});

export const crmStatusesSelectors = crmStatusesAdapter.getSelectors((state: RootState) => state.crmStatuses);
